export default __webpack_public_path__ + "static/P_SearchThumb_IN-4010_Downloads-29b8cb976ce9f085f947be3ec9a7e5e0.webp";